import _ from "lodash"
import { EMPLOYEE } from "../../../consts/methods.consts"
import { useGetQuery } from "../../../services/api.service"
import { EMPLOYEE_TAGS } from "../../../consts/tags.consts"
import { useTableDataProvider } from "../../hooks"
import PageHeader, { PageHeaderActions } from "../../common/page-header/PageHeader"
import ChakraTable, { ChakraTableColumns } from "../../common/chakra-table/ChakraTable"
import { NavigateFunction, useNavigate, useSearchParams } from "react-router-dom"
import { useRef, useState } from "react"

const EMPLOYEE_COLUMNS: ChakraTableColumns = [
    {
        header: "NIC",
        accessor: "nic",
    },
    {
        header: "Salutation",
        accessor: "salutation",
    },
    {
        header: "Name",
        accessor: "full_name",
    },
    {
        header: "Type",
        accessor: "type",
    },
    {
        header: "Location",
        accessor: "location",
    }
]

const EmployeeListPage = () => {
    const navigate: NavigateFunction = useNavigate()
    const [page, setPage] = useState(1)
    const [searchKey, setSearchKey]: any = useState()
    const [length, setLength] = useState(15)

    const { data, isLoading, isFetching } = useGetQuery({
        method: EMPLOYEE.LIST,
        body: {
            page: page,
            length: Number(length),
            key: searchKey
        },
        providesTags: [EMPLOYEE_TAGS.LIST]
    })

    const { dataList, paginationDetails } = useTableDataProvider(data);

    const actions: PageHeaderActions = [

        {
            text: "Create New",
            onClick: () => navigate("new"),
            confirmation: false,
            buttonVariant: "solid",
            buttonColorScheme: "teal"
        }
    ]

    const tableLineClickHandler = (line: any) => {
        navigate(`${_.get(line, 'name')}`)
    }

    const onSearchHandler = (value: any) => {
        setPage(1)
        let deb = _.debounce(() => {
            setSearchKey(value)
        }, 250)

        deb()
    }

    const onLengthChange = (length: any) => {
        setPage(1)
        setLength(Number(length))
    }

    const onPage = (page: any) => {
        setPage(page)
    }

    return (
        <div>
            <PageHeader subtitle="View and Manage Employees" title={`Employee`} actions={actions} />
            <ChakraTable onPage={onPage} onLength={onLengthChange} lengthPaginations isFetching={isFetching} onSearch={onSearchHandler} paginationDetails={paginationDetails} isLoading={isLoading} pagination size={"sm"} header title="Employees"
                onSelected={tableLineClickHandler} columns={EMPLOYEE_COLUMNS} data={dataList} />
        </div>
    )
}

export default EmployeeListPage